export default {

    state: {
        value: false,
    },

    mutations: {
        activePreventQuitFormular(state) {
            state.value = true;
        },
        disablePreventQuitFormular(state) {
            state.value = false;
        },
    },

    actions: {
        activePreventQuitFormular({ commit }) {
            commit('activePreventQuitFormular');
        },
        disablePreventQuitFormular({ commit }) {
            commit('disablePreventQuitFormular');
        },
    },
    getters: {
        preventQuitFormular: state => state.value,
    },
};
